import Logout from './account/dialog/authenticate/Logout'

const routes = [
  // {path: '/', name: 'home'},
  {path: '/login/:token', name: 'token_login'},
  {path: '/logout', name: 'logout', component: Logout},
  {path: '/market', name: 'market'},
]

const mbRouter = {
  mode: 'history',
  hash: false,
  base: '/',
  routes
}

export default mbRouter
